import { useRouter } from '@tellus/router'
// import useStore from '@/store'
import { BindTrapTabKeyEvent } from '@tellus/utils/src/dom'
import Vue from 'vue'
import clone from 'xe-utils/clone'
import { useLocale } from '@tellus/locale'

function handle(checkFunction, afterHandel) {
  if (checkFunction instanceof Function) {
    const res = checkFunction()
    if (res instanceof Promise) {
      res.then(c => {
        c && afterHandel()
      })
    } else {
      res && afterHandel()
    }
  } else {
    checkFunction || afterHandel()
  }
}

function mergeModalProps(modalProps, vmInstance) {
  const modalModel = modalProps?.model
  modalProps?.model && delete modalProps.model
  const mergedModalProps = Object.assign(modalModel ? { model: modalModel } : {}, {
    props: Object.assign(
      {
        // top: '0',
        'custom-class': !modalProps?.props?.title ? 'hide' : '',
        'destroy-on-close': true,
        'close-on-click-modal': false,
        'close-on-press-escape': false,
        'lock-scroll': false,
        showClose: true,
        visible: vmInstance.visible
      },
      clone(modalProps.props ? modalProps.props : {}, true)
    ),
    attrs: clone(modalProps?.attrs || {}, true),
    style: clone(modalProps?.style || {}, true),
    class: clone(modalProps?.class || {}, true),
    on: Object.assign({}, clone(modalProps?.on || {}, true), {
      close: vmInstance.handleClose
    })
  })
  return mergedModalProps
}
function mergeComponentProps(componentProps, vmInstance) {
  const componentModel = componentProps?.model
  componentProps?.model && delete componentProps.model
  const mergedComponentProps = Object.assign(componentModel ? { model: componentModel } : {}, {
    ref: '_component',
    props: clone(componentProps?.props || {}, true),
    attrs: clone(componentProps?.attrs || {}, true),
    style: clone(componentProps?.style || {}, true),
    class: clone(componentProps?.class || {}, true),
    on: Object.assign(clone(componentProps?.on || {}, true), {
      close: vmInstance.handleClose,
      ok: vmInstance.handleOk,
      cancel: vmInstance.handleClose
    })
  })
  return mergedComponentProps
}

export default function dialog(component, componentProps, modalProps = {}) {
  if (!component) {
    throw new Error(`Not found Component of '${component}'`)
  }

  const el = document.createElement('div')
  const dialogDiv = document.createElement('div')
  dialogDiv.setAttribute('type', 'dialog')
  dialogDiv.appendChild(el)
  document.body.appendChild(dialogDiv)

  function destroy() {
    if (dialogInstance && dialogDiv?.parentNode) {
      dialogInstance.UnBindTabKeyEvent()
      dialogInstance.$off('close')
      dialogInstance.$destroy()
      dialogInstance = null
      dialogDiv.parentNode?.removeChild(dialogDiv)
    }
  }

  let dialogInstance = new Vue({
    el: el,
    data() {
      return {
        visible: true
      }
    },
    router: useRouter(),
    // store: useStore(),
    i18n: useLocale(),
    mounted() {
      this.$nextTick().then(() => {
        this.UnBindTabKeyEvent = BindTrapTabKeyEvent(this.$el)
      })
      this.$on('close', () => {
        this.handleClose()
      })
    },
    methods: {
      handleClose() {
        // When a component is a functional component, there is no ref property.
        handle(this.$refs._component?.onCancel, () => {
          destroy()
          this.visible = false
          componentProps?.on?.close && componentProps?.on?.close(...arguments)
          componentProps?.on?.cancel && componentProps?.on?.cancel(...arguments)
          modalProps?.on?.cancel && modalProps?.on?.cancel()
        })
      },
      handleOk() {
        handle(this.$refs._component?.onOK, () => {
          destroy()
          this.visible = false
          componentProps?.on?.close && componentProps?.on?.close(...arguments)
          componentProps?.on?.ok && componentProps?.on?.ok(...arguments)
          modalProps?.on?.ok && modalProps?.on?.ok()
        })
      }
    },
    render: function (h) {
      const that = this
      const ModalProps = mergeModalProps(modalProps, that)
      const ComponentProps = mergeComponentProps(componentProps, that)
      return h('t-dialog', ModalProps, [h(component, ComponentProps)])
    }
  })
  return dialogInstance
}
